
<template>
  <div class="markbox" v-show="loading" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="sun-loading"></div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  data() {
    return {
      loading: false
    }
  },
  created() {
    var that = this;
    this.bus.$on('loading', function (data) {
      that.loading = !!data;
    })
  }
}
</script>

<style scoped>
.sun-loading {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/loading.vue